"use client";

import {JSX} from "react";

import {ExpandableTextWithButton} from "@/shared/ui/data-display/expandable-text";
import {Typography} from "@/shared/ui/data-display/typography";

interface CardItemProps {
    title: string;
    text: string;
}

export function CardItem({title, text}: CardItemProps): JSX.Element {
    return (
        <div className="info-cards-section__card">
            <div className="info-cards-section__card-intro">
                <Typography as="h3" size={{desktop: 16, mobile: 14}} weight={500} className="info-cards-section__card-title">
                    {title}
                </Typography>

                <ExpandableTextWithButton
                    maxLines={{
                        desktop: 6,
                        mobile: 4,
                    }}
                    charCount={text?.length}
                    buttonClassName="info-cards-section__readmore-button"
                    buttonMarginTop={25}
                    ssrEstimation={{
                        desktop: {width: 500, fontSize: 14},
                        mobile: {width: 420, fontSize: 12},
                    }}
                >
                    <Typography as="p" size={{desktop: 14, mobile: 12}} weight={400} color="paragraph" className="info-cards-section__card-text">
                        {text}
                    </Typography>
                </ExpandableTextWithButton>
            </div>
        </div>
    );
}
